import { CloseButton, Dialog, newToast, pn, Stack, Typography, useValidationErrors } from "@compass/core";
import { Input, SubmitButton } from "components";
import { UserExportDisplayField, UserExportDisplayFieldsSnapshot } from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setAppToast } from "redux/reducers/appSlice";
import ApiService from "services/apiService";

export const DisplaySnapshotMenuCreate = (props: {
  displayFields: string[];
  onClose: () => void;
  onSave: () => void;
  exportTypeId?: number;
  exportSubTypeId?: number;
}) => {
  const dispatch = useDispatch();

  const [snapshot, setSnapshot] = useState<UserExportDisplayFieldsSnapshot>({} as UserExportDisplayFieldsSnapshot);
  const { validationErrors, setValidationErrors } = useValidationErrors();

  useEffect(() => {
    ApiService.exports.getDisplayFieldsSnapshot(0).then((response) => {
      response.exportTypeId = props.exportTypeId;
      response.exportSubTypeId = props.exportSubTypeId;
      response.displayFields = props.displayFields.map((name) => ({ name } as UserExportDisplayField));
      setSnapshot(response);
    });
  }, []);

  const save = (snapshot: UserExportDisplayFieldsSnapshot) => {
    setValidationErrors({});

    ApiService.exports
      .saveDisplayFieldsSnapshot(snapshot)
      .then(() => {
        dispatch(setAppToast(newToast("success")));
        props.onClose();
        props.onSave();
      })
      .catch((ex) => {
        dispatch(setAppToast(newToast("error")));
        setValidationErrors(ex.response);
      });
  };

  return (
    <Dialog
      isForm
      open={true}
      header={
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="inherit">New Snapshot</Typography>

          <Stack direction="row" alignItems="center" spacing="sm">
            <CloseButton theme="Dark" onClick={() => props.onClose()} />
            <SubmitButton theme="Dark" onClick={() => save(snapshot)} />
          </Stack>
        </Stack>
      }
      content={
        <Stack spacing="md">
          <Input
            label="Snapshot name"
            required
            value={snapshot?.name}
            onChange={(e) =>
              setSnapshot(
                produce((draft) => {
                  draft.name = e.target.value;
                })
              )
            }
            errors={validationErrors?.[pn<UserExportDisplayFieldsSnapshot>("name")]}
          />

          <Typography variant="caption">
            Adding <b>{props.displayFields.length}</b> fields to your snapshot. Saving a snapshot will remember your
            selected fields preference into a profile, which can be used later to quickly select fields.
          </Typography>
        </Stack>
      }
    />
  );
};
